import { PatientApplicantId } from '@app/icare/entities/patient/schema/PatientApplicant'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientApplicantOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_applicant/-components/PatientApplicantOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_applicant/anmelder/$relation')({
  params: entityParams({ id: PatientId, relation: PatientApplicantId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientApplicantOverview patientId={id} relationId={relation} />
}
